export default __webpack_public_path__ + "static/media/empty-filtered-sprint-chart.a37f5fd8.svg";